<div class="follow-stream">
  <div class="follow-toolbar">
    <button
      mat-stroked-button
      type="button"
      [disabled]="flowBusy || !filter"
      (click)="showFlowGraph()"
      >
      {{ flowData ? 'Stream contents' : 'Flow Graph' }}
    </button>
    @if (meta) {
      <span class="follow-meta">{{ meta }}</span>
    }
    @if (filter) {
      <span class="follow-filter">{{ filter }}</span>
    }
  </div>
  @if (error) {
    <p class="follow-error">{{ error }}</p>
  }
  @if (flowData) {
    <div class="follow-flow">
      <tap-flow [data]="flowData"></tap-flow>
    </div>
  }
  @if (!flowData && chunks.length) {
    <pre class="follow-payload">@for (chunk of chunks; track chunk) {
      <span class="chunk" [class.server]="chunk.s" (click)="selectChunk(chunk)">{{ chunk.d }}</span>
    }</pre>
  }
</div>
